import { Component, inject } from '@angular/core';

import { AppPreferences } from '../../../core/services/app-preferences';
import { AppIcon, AppIconName } from '../../../shared/app-icon/app-icon';

type Step = {
  key: string;
  icon: AppIconName | string;
};

@Component({
  selector: 'app-steps-section',
  imports: [AppIcon],
  templateUrl: './steps-section.html',
  styleUrl: './steps-section.scss',
})
export class StepsSection {
  readonly preferences = inject(AppPreferences);
  readonly steps: Step[] = [
    { key: 'details', icon: 'enter-your-details' },
    { key: 'eligibility', icon: 'check-your-eligibility' },
    { key: 'offers', icon: 'show-offers' },
    { key: 'submit', icon: '/assets/images/landing-page/submitting-application.svg' },
  ];

  isInlineIcon(icon: string): icon is AppIconName {
    return !icon.startsWith('/');
  }
}
